// sagas/closureSaga.js
import { takeLatest, call, put } from "redux-saga/effects";
import api from "../../../services/api";
import {
  SUBMIT_CLOSURE_REQUEST,
  submitClosureSuccess,
  submitClosureFailure
} from "../actions/closureAgentActions";
import { fetchClosureAgent } from "../../../services/accIqService";

// Saga function
function* handleClosureSubmission(action) {
  try {
    const response = yield call(
        fetchClosureAgent, 
        action.payload.clientName, 
        action.payload.accountName, 
        action.payload.contact, 
        action.payload.context,
        action.payload.contextFile,
        action.payload.outputFile,
        action.payload.responseType
    );
    yield put(submitClosureSuccess(response?.html || "No closure note generated."));
  } catch (error) {
    yield put(submitClosureFailure(error.error));
  }
}

export function* watchClosureSubmission() {
  yield takeLatest(SUBMIT_CLOSURE_REQUEST, handleClosureSubmission);
}